@if (!(hasLoadedChart$ | ngrxPush)) {
    <wdx-spinner class="absolute-center"></wdx-spinner>
}

<section class="h-100 d-flex flex-column overflow-hidden">
    <section class="align-self-end {{ iconButtonClass }} mb-1">
        <atom-icon-button
            size="sm"
            icon="expand-arrows-alt"
            (onClick)="openModalFullScreen()"
        ></atom-icon-button>
    </section>

    @if (hasLoadedChart$ | ngrxPush) {
        <powerbi-report
            class="w-100 flex-grow-1"
            [cssClassName]="reportClass"
            [embedConfig]="reportConfig$ | ngrxPush"
            [phasedEmbedding]="phasedEmbeddingFlag"
        ></powerbi-report>
    }
</section>

<atom-modal-wrapper
    size="full"
    modalId="powerBiModal"
    [modalTemplate]="powerBiModal"
>
    <ng-template #powerBiModal>
        <organism-modal modalTitle="Portfolio 360">
            @if (hasLoadedChart$ | ngrxPush) {
                <powerbi-report
                    class="w-100 h-100"
                    [cssClassName]="reportClass"
                    [embedConfig]="reportConfig$ | ngrxPush"
                    [phasedEmbedding]="phasedEmbeddingFlag"
                ></powerbi-report>
            }
        </organism-modal>
    </ng-template>
</atom-modal-wrapper>
